// extracted by mini-css-extract-plugin
module.exports = {"root":"footer-module--root--24vR9","footer":"footer-module--footer--2r2aa","nav":"footer-module--nav--8v6HN","icons":"footer-module--icons--3-U_H"};